// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PancardDetailsActionType from './pancard-details.types';
import {
	updatePancardSuccess,
	updatePancardFailure,
	updatePancardResponseChanged,
} from './pancard-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { pancardUpdateDetails } from './pancard-details.service';

/** ***************** Pancard Update Start ************************/
export function* updatePancardIdDetails({ payload }: any) {
	try {
		const key = 'updatePancardID';
		const {
			companyID,
			databaseName,
			memberID,
			memberPanCardFrontImg,
			memberPanCardBackImg,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberPancardFrontImg: memberPanCardFrontImg,
			MemberPancardBackImg: memberPanCardBackImg,
			OfficerID: userID,
			Secratekey: key,
		};

		const pancardData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(pancardUpdateDetails, pancardData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePancardFailure(responseData.data));
		} else {
			yield put(updatePancardSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePancardFailure(error));
	}
}

export function* updatePancardDetailsResponseClear() {
	yield put(updatePancardResponseChanged());
}

export function* onPancardDetailsUpdateStart() {
	yield takeLatest(PancardDetailsActionType.UPDATE_PANCARD_START, updatePancardIdDetails);
}

export function* onPancardDetailsUpdateResponseRest() {
	yield takeLatest(
		PancardDetailsActionType.UPDATE_PANCARD_RESPONSE_REST_START,
		updatePancardDetailsResponseClear,
	);
}
/** ***************** Pancard Update End ************************/

export function* pancardDetailsSaga() {
	yield all([call(onPancardDetailsUpdateStart), call(onPancardDetailsUpdateResponseRest)]);
}
